import ReactMarkdown from 'react-markdown';
import { Prism as ReactSyntaxHighlighter } from 'react-syntax-highlighter';
// BlogLayoutTuto.tsx
import React from 'react';
import Image from 'next/image';
import { Post } from '../PostType'; // Utilisez vos types définis
import style from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark';

interface BlogLayoutTutoProps {
    post: Post;
    setToggleSignForm: React.Dispatch<React.SetStateAction<boolean>>;
}

const BlogLayoutTuto: React.FC<BlogLayoutTutoProps> = ({ post, setToggleSignForm }) => {
    return (
        <article className="max-w-4xl mx-auto bg-white rounded-lg shadow">
            <div className='relative'>
                <Image src={post.imageUrl} alt={`Image for ${post.title}`} className="w-full object-cover rounded-sm" width={700}
                    height={475} />
                <div className='absolute bottom-2 left-0 bg-black2/80 flex p-4 justify-start mr-2'>
                    <h1 className="text-3xl font-bold my-2 ">{post.content.h1}</h1>
                </div>
            </div>

            {post.content.markdown && (
                <ReactMarkdown className="text-black2 p-8 markdown">
                    {post.content.markdown}
                    {/* {"## Mon Titre"} */}
                </ReactMarkdown>
            )}
            <p onClick={() => setToggleSignForm(true)} className="text-blue-600 hover:text-blue-800 cursor-pointer p-6">{post.content.callToAction}</p>

            <div className="p-6">
                <div className="flex justify-between items-center flex-col sm:flex-row gap-4">
                    <div className="flex gap-2 items-center text-sm">
                        {post.category.map((category, index) => (
                            <span key={index} className="bg-gray-200 rounded-full px-3 py-1 font-semibold text-brand">{category}</span>
                        ))}
                    </div>
                    <div className="text-sm text-gray-500">
                        <span className="font-medium">{post.author}</span>
                        <span className="mx-2">•</span>
                        <time dateTime={post.date}>{new Date(post.date).toLocaleDateString()}</time>
                    </div>
                </div>
            </div>
        </article>
    );
};

export default BlogLayoutTuto;
